import React, { useState ,useEffect} from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { Link,useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <nav className="bg-gray-800 p-4 text-white fixed w-full z-10 top-0" style={{ cursor: 'default' }}>
      <div className="mx-auto text-center flex w-5/6 justify-between">
        
        <div className="hidden sm:flex space-x-4 items-center text-sm">
          <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            <Link to='/' className="hover:text-yellow-200 transition-colors">Home</Link>
          </motion.div>
          <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            <Link to='/about' className="hover:text-yellow-200 transition-colors">About</Link>
          </motion.div>
        </div>
        <motion.div 
          className="text-3xl sm:text-2xl font-extrabold"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <a href="/" className="hover:text-yellow-200 transition-colors">Pranav</a>
        </motion.div>
        <div className="hidden sm:flex space-x-4 items-center text-sm">
          <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            <Link to='/projects' className="hover:text-yellow-200 transition-colors">Projects</Link>
          </motion.div>
          <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            <Link to='/experience' className="hover:text-yellow-200 transition-colors">Experience</Link>
          </motion.div>
          <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            <Link to='/contact' className="hover:text-yellow-200 transition-colors">Contact</Link>
          </motion.div>
        </div>

        <div className="sm:hidden">
          <motion.button 
            onClick={toggleMobileMenu} 
            className="text-xl focus:outline-none"
            whileTap={{ scale: 0.9 }}
          >
            {isMobileMenuOpen ? '✕' : '☰'}
          </motion.button>
        </div>
        <AnimatePresence>
          {isMobileMenuOpen && (
            <motion.div 
              className="sm:hidden fixed top-0 left-0 w-full h-full bg-gray-800 text-center flex flex-col items-center justify-center z-50"
              initial={{ opacity: 0, x: "100%" }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: "100%" }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <motion.button 
                onClick={closeMobileMenu} 
                className="text-xl absolute top-4 right-4 focus:outline-none"
                whileHover={{ rotate: 90 }}
                whileTap={{ scale: 0.9 }}
              >
                ✕
              </motion.button>
              <motion.ul 
                className="font-medium text-2xl space-y-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                {[
                  { path: '/', label: 'Home' },
                  { path: '/about', label: 'About' },
                  { path: '/projects', label: 'Projects' },
                  { path: '/experience', label: 'Experience' },
                  { path: '/contact', label: 'Contact' }
                ].map((item, index) => (
                  <motion.li
                    key={item.path}
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.3 + index * 0.1 }}
                  >
                    <Link 
                      to={item.path} 
                      onClick={closeMobileMenu}
                      className="block hover:text-yellow-200 transition-colors"
                    >
                      {item.label}
                    </Link>
                  </motion.li>
                ))}
              </motion.ul>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default Navbar;
